<template>
  <div class="h5-button">
    <button :class="brand == 'COTTI' ? 'open-action' : 'open-action-tc'" :style="buttonStyle" @click="handleH5Download">{{ buttonTxt }}</button>
  </div>
</template>

<script>
import { isAndroid, isIOS, isWeixin } from '../../utils'
import qs from 'qs'
export default {
  name: 'H5Button',
  data(){
    return {
      isInstallShow : isAndroid() && !isWeixin() && (this.type === 'default'),
      brand: this.$config.env.VUE_APP_BRAND
    }
  },
  props: {
    buttonStyle: {
      type: String,
      default: '',
    },
    buttonTxt: {  
      type: String,
      default: '立即下载',
    },
    androidAPKUrl: {
      type: String,
      default: '',
    },
    type: {
      type: String,
    },
    point: {
      type: String,
    },
    itemNo: [String, Number],
    subKdtId: [String, Number],
    itemId: [String, Number],
  },
  mounted(){
    // 当显示"已安装"按钮时，通知祖先组件（部分需求要根据两个按钮时控制页面样式）
    if (this.isInstallShow) {
      this.$emit('isInstallShow', true)
    }
  },
  methods:{
    channelClickMonitor(){
      const utm_source = qs.parse(window.location.search, { ignoreQueryPrefix: true }).utm_source
      const code = this.$route.query.c || utm_source || ''
      console.log(code,'code')
      this.$sensors.track('channel_appDownloadPage_click', { code });
      // 参与页下载单独埋点
      if(this.type === 'participate' && this.point){
        console.log(this.point,'point')
        this.$sensors.track(this.point);
      }
    },
    handleH5Download(){
      console.log(this.itemNo)
      this.channelClickMonitor()
      if(isIOS()){
        console.log('h5-iOS',this.type)
        if(this.type === 'default'){
           if (this.brand === "COTTI") {
              window.location.href = 'https://apps.apple.com/cn/app/id1661236690'
            } else {
              window.location.href = 'https://apps.apple.com/cn/app/id6473227178'
            }
        }
      }
        
      if(isAndroid()){
        console.log('h5-android',this.type)
        if(this.type === 'default'){
          return window.location.href = this.androidAPKUrl
        }
      }
    },
    handleInstalledOpenAction(){
      this.$toast({ message: '如打开失败，请您自行操作'});
      this.channelClickMonitor()
      if(this.type === 'default'){
        return window.location.href = 'abite://dj/abitetab/tabpage?index=0' // todo 需要替换链接
      }
    }
  }
}
</script>

<style lang="scss">

.h5-button{
  display: flex;
  flex-direction: column;
  .open-action{
    background: #A52337;
    width: 542px;
    height: 90px;
    border-radius: 46px;
    box-shadow: 0px 2px 4px 0px rgba(143,92,92,0.12);
    font-size: 32px;
    font-weight: 500;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    outline: none;
    // margin-bottom: 24px;
  }
  .open-action-tc{
    background: #9FCC0C;
    width: 542px;
    height: 90px;
    border-radius: 46px;
    box-shadow: 0px 2px 4px 0px rgba(143,92,92,0.12);
    font-size: 32px;
    font-weight: 500;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    outline: none;
    margin-bottom: 24px;
  }
  .install-action{
    width: 542px;
    height: 90px;
    border-radius: 6px;
    background: white;
    border: 1px solid #E45D50;
    font-size: 32px;
    font-weight: 500;
    color: #E45D50;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

</style>
